import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const updateCustomizationLogo = async (
  { merchantLogo, reset = false }
    :
    { merchantLogo?: File | null, reset?: boolean }
) => {

  if (reset || !merchantLogo) {
    return axiosPrivate.post(`/dashboard/api/v1/checkout-customization/update-logo`, {});
  };

  const reqBody = new FormData();
  reqBody.append('merchant_logo', merchantLogo);

  const headers = {
    'Content-Type': 'multipart/form-data'
  };

  return axiosPrivate.post(`/dashboard/api/v1/checkout-customization/update-logo`, reqBody, { headers: headers });
};